import React from 'react'
import { useLocation } from 'react-router'
import { hasScrollRestoreOverride } from './helpers/scrollRestoreOverride'

export const ScrollRestoration = () => {
  const location = useLocation()

  React.useEffect(() => {
    if (hasScrollRestoreOverride(location.key)) return

    window.scrollTo(0, 0)
  }, [location])

  return null
}
